<template>
	<v-navigation-drawer v-model="drawer" width="300" dark app>
		<div class="account-navigation-drawer">
			<div class="sidebar-container">
				<AccountMenu />

				<v-list>
					<v-list-item @click="backToApp" class="menu-item">
						<v-list-item-icon>
							<v-icon>mdi mdi-chevron-left</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="navigation-item">
								Back to App
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<template v-for="menuItem in filteredMenuItems">
						<v-list-item
							v-if="!menuItem.children"
							:key="menuItem.route"
							class="menu-item"
							:class="{ selected: $route.name === menuItem.route }"
							@click="goToRoute(menuItem.route, menuItem.display)"
							:disabled="!menuItem.enabled"
						>
							<v-list-item-icon>
								<v-icon>{{ menuItem.icon }}</v-icon>
							</v-list-item-icon>

							<v-list-item-content>
								<v-list-item-title class="navigation-item">
									{{ menuItem.display }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
				</v-list>
			</div>
		</div>
	</v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import AccountMenu from "@/components/account-menu/Menu.vue";
import CanMixin from "@/mixins/CanMixin";

export default {
	mixins: [CanMixin],

	components: {
		AccountMenu,
	},
	created() {
		this.menuItems.forEach(menuItem => {
			let activeItem = null;
			if (menuItem.route === this.$route.name) {
				activeItem = menuItem;
			} else if (menuItem.children) {
				activeItem = menuItem.children.find(item => item.route === this.$route.name);
			}

			if (activeItem) {
				this.$eventBus.$emit("route-update", { title: activeItem.display });
			}
		});

		this.$eventBus.$on("account-toggle-drawer", () => {
			this.drawer = !this.drawer;
		});
	},

	data() {
		return {
			drawer: this.$vuetify.breakpoint.mdAndUp,
		};
	},

	computed: {
		...mapState("User", ["user"]),

		menuItems() {
			return [
				{
					icon: "mdi mdi-home",
					display: "Account Overview",
					route: "account.profile",
					enabled: true,
					active: this.$route.name === "account.profile",
				},
                {
                    icon: "mdi mdi-shield",
                    display: "Account Security",
                    route: "account.security",
                    enabled: true,
                    active: this.$route.name === "account.security",
                },
                {
                    icon: "mdi mdi-message",
                    display: "Email Notifications",
                    route: "account.notifications",
                    enabled: this.canSeeEmailNotificationsPage,
                    active: this.$route.name === "account.notifications",
                },
				{
					icon: "mdi mdi-account-circle",
					display: "Users",
					route: "account.users",
					enabled: this.canSeeUsersPage,
					active: this.$route.name === "account.users",
				},
                {
                    icon: "mdi mdi-account-multiple",
                    display: "Guests",
                    route: "account.guests",
                    enabled: this.canSeeGuestsPage,
                    active: this.$route.name === "account.guests",
                },
				{
					icon: "mdi mdi-account-group",
					display: "Groups",
					route: "account.groups",
					enabled: this.canSeeGuestsPage,
					active: this.$route.name === "account.groups",
				},
				{
					icon: "mdi mdi-credit-card-outline",
					display: "Billing",
					route: "account.billing",
					enabled: this.canSeeBillingPage,
					active: this.$route.name === "account.billing",
				},
				{
					icon: "mdi mdi-apps",
					display: "Project Management",
					route: "account.projects",
					enabled: this.canSeeProjectManagementPage,
					active: this.$route.name === "account.projects",
				},
			];
		},

		filteredMenuItems() {
			return _.cloneDeep(this.menuItems).map(menuItem => {
				if (menuItem.children) {
					menuItem.children = menuItem.children.filter(item => item.enabled);
				}

				return menuItem;
			});
			// .filter(menuItem => menuItem.enabled || (menuItem.children && menuItem.children.length));
		},
	},

	methods: {
		goToRoute(route, display) {
			if (this.$route.name === route) {
				return;
			}

			this.$eventBus.$emit("route-update", { title: display });
			this.$router.push({ name: route });
		},
		backToApp() {
			// this.$store.dispatch("resetApp");
			// this.$router.replace({ name: "app" });
			location.replace("/");
		},
	},
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
    position: initial;
}

.account-navigation-drawer {
	background: #121212;
	height: 100%;

	.sidebar-container {
		height: 100%;

		#user-container {
			padding: 12px 16px 0;
		}

		.v-list {
			background: transparent;
			padding: 0;
			border-bottom: 1px solid #212121;
			font-size: 15px;
		}

		.menu-item {
			display: flex;
			align-items: center;

			&:first-of-type {
				margin: 2rem 0;
			}
			&:not(:first-of-type) {
				border-top: 1px solid #212121;
			}
			&:after {
				display: none;
			}
			&:before {
				height: 100%;
				top: 0;
				left: 0;
				background-color: var(--primary);
				bottom: initial;
				right: initial;
				display: none;
			}

			&.selected:before {
				width: 4px;
				display: block;
				opacity: 1;
			}

			.v-list-item__icon {
				margin-right: 1rem;
				min-width: initial;
				.v-icon {
					color: #989898;
					font-size: 18px;
				}
			}

			.v-list-item__content {
				color: #989898;
			}

			&.v-list-item--disabled {
				opacity: 0.3;
			}
		}
	}
}

.navigation-item {
	font-size: 16px;
	margin-top: 1px;
}
</style>
